import React from "react";
import { isEmpty, isEqual } from "lodash";
import { Model } from "survey-core";
import { SvgAssets } from "../../../../components/icon/assets";
import { submitApplicationFormAsync } from "../../redux/onboarding-slice";
import {
  FormAction,
  OnboardingFormModuleName,
  OnboardingApplicationSectionStatus,
  OnboardingFormSectionName,
  RoleEnum,
} from "../../types";
import { preQuestionsData } from "./survey-form.screen";
import { getI18n } from "react-i18next";
import { confirm } from "../../../../components/modal/comfirm";
import Icon from "../../../../components/icon/icon";
import { GlobalHelper } from "../../../../utils/helpers/global-helper";
import store from "../../../../redux/store";
import moment from "moment";
import {
  postNPAToken,
  postCreateNPA,
  fetchCandidateOnboardingForm,
  getFile,
  postPayloadTemporary,
  getAgentProfilePruOne,
  getDetailAgentSpouse,
  getTodoTasks,
  getDocFromDB,
  uploadFile,
  submitApplicationForm,
  updateActiveFlag,
  formCancelCandidate,
  postPayloadTemporaryCandidateAddress,
  closeNotification,
} from "../../network/network";
import { PruToast } from "../../../../components/pru-toast";
import { getToken, parseJwt } from "../../utils";
import { StorageFileTypeEnum } from "../../network/file-op-interface";
import { base64ToBlob } from "../../components/surveyjs/file/base64";

function stringifyNumbers(data: any) {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (typeof value === "number") {
        data[key] = value.toString();
      }
    }
  }
  return data;
}
function removeUndefinedAndNullValues<T>(list: T[]): T[] {
  const newList: T[] = [];
  list.forEach((v) => {
    if (v !== null && v !== undefined) newList.push(v);
  });
  return newList;
}

function removeUndefined(obj: any): any {
  if (Array.isArray(obj)) {
    const newlist = removeUndefinedAndNullValues(obj);
    return newlist.map(removeUndefined);
  } else if (typeof obj === "object" && obj !== null) {
    const newObj: { [key: string]: any } = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = removeUndefined(obj[key]);
        if (value !== undefined) {
          newObj[key] = value;
        }
      }
    }
    return newObj;
  } else {
    return obj;
  }
}

function normalizeWhitespaces(value: any, keyPath: string[] = []): any {
  if (typeof value === "string") {
    return value.replace(/\s{2,}/g, " ").trim();
  }
  if (Array.isArray(value)) {
    return value.map((item) => normalizeWhitespaces(item, keyPath));
  }
  if (value && typeof value === "object") {
    const normalizedObj: Record<string, any> = {};
    for (const key in value) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        normalizedObj[key] = normalizeWhitespaces(value[key], [...keyPath, key]);
      }
    }
    return normalizedObj;
  }
  return value;
}

async function setPayloadSupportingDocument(
  dataImg: any,
  applicationId: string,
  docId: string,
): Promise<any> {
  const imgData = dataImg;
  let contentImg: any;
  let imgType: any;
  for (const a in imgData) {
    contentImg = await getFile({
      applicationId: applicationId,
      resourceId: imgData[a].content,
    });
    if (contentImg?.statusCode == 503) {
      PruToast({
        message: getI18n().t("Common.network_error_502"),
        duration: 2000,
      });
      return { error: {} };
    }
    imgType = contentImg.data.mimeType.split("/");
    const dataContent = {
      mime: contentImg.data.mimeType,
      docId: docId,
      docType: imgType[1],
      fileDoc: contentImg.data.fileContent,
      fileType: imgType[0],
      scanTimestamp: moment().format("HH:mm"),
    };
    return dataContent;
  }
}

async function downloadAndUploadDoc(
  npaNumber: string,
  docId: string,
  applicationId: string,
  questionName: string,
  fileName: string,
  fileType: string,
) {
  const payloadData = {
    npaNo: npaNumber,
    docId: docId,
  };
  const resData = await getDocFromDB(payloadData);
  if (resData?.result?.documents[0]) {
    const mimeType = resData?.result?.documents[0].mime;
    const payloadFile = {
      moduleName: "eSignatureModule",
      sectionName: "eSignatureSection",
      applicationId: applicationId,
      questionName: questionName,
      fileName: `${fileName} ${moment().format("YYYY-mm-DD hh.mm.ss")}`,
      index: 2,
      fileType:
        fileType == "uploadDoc"
          ? StorageFileTypeEnum.UPLOAD_DOCUMENT
          : StorageFileTypeEnum.SIGNATURE,
      file: base64ToBlob(resData?.result?.documents[0].fileDoc, mimeType),
      mimeType: mimeType,
    };
    const resUploadRecID = await uploadFile(payloadFile);
    if (!resUploadRecID.data) {
      return false;
    } else {
      return resUploadRecID.data;
    }
  } else {
    return false;
  }
}

async function cancelNPA(result: any, agentCodeSpouse: string) {
  const payloadFlagSubmit = {
    npaNumber: result.data[0].npaNumber,
    spouseagentcode: agentCodeSpouse,
  };
  const activeFlagSubmit = await updateActiveFlag(payloadFlagSubmit);
  const payloadCancelCandidate = {
    templateId: result.data[0].templateId,
    candidateId: result.data[0].candidateId,
    applicationId: result.data[0].applicationId,
    operatorId: result.data[0].candidateId,
    operatorRole: "CANDIDATE",
  };
  if (activeFlagSubmit?.code == "200") {
    const resCancelCandidate = await formCancelCandidate(payloadCancelCandidate);
    if (resCancelCandidate?.statusCode == 500) {
      confirm({
        message: getI18n().t("Common.network_error_502"),
        confirmButtonText: "OK",
        disableCancel: true,
      });
      return { error: {} };
    } else {
      return { backToFak: true };
    }
  } else {
    return { error: {} };
  }
}

export const submitOnboardingForm = async ({
  data,
  dispatch,
  formAction,
  notificationActionId,
}: any) => {
  const currentSection = GlobalHelper.getOnboardingCurrentSection();
  const candidateId = currentSection.candidateId;
  const moduleName = currentSection.moduleName;
  const sectionName = currentSection.name;
  if (!candidateId) return;
  // get section from candidateOnboardingForm by sectionName
  const candidateOnboardingForm = store.getState()?.onboarding?.candidateOnboardingForm;
  const formTemplate = store.getState()?.onboarding?.currentTemplate;
  const section = candidateOnboardingForm?.modules?.[moduleName]?.[sectionName];
  const currentSectionQuestionKeys: string[] =
    formTemplate.pages
      .find((page: any) => page.name === moduleName)
      .elements.find((section: any) => section.name === sectionName)
      .elements.map((q: any) => q.name) ?? [];
  const sectionQuestionAnswers = section?.questionAnswers;
  const dataWithoutUndefined = normalizeWhitespaces(removeUndefined(data));
  for (const key in dataWithoutUndefined) {
    if (Object.prototype.hasOwnProperty.call(dataWithoutUndefined, key)) {
      if (!currentSectionQuestionKeys.includes(key)) {
        delete dataWithoutUndefined[key];
      }
    }
  }
  if (isEmpty(dataWithoutUndefined) && formAction === FormAction.SAVE) {
    return { noNeedToast: true };
  }

  if (
    !candidateOnboardingForm?.npaNumber &&
    currentSection.name == "identificationInformation" &&
    formAction === FormAction.SUBMIT
  ) {
    const getNPAToken = await postNPAToken();
    if (getNPAToken?.data?.npaToken) {
      const recruiterProfile = await getAgentProfilePruOne(
        candidateOnboardingForm?.recruiterInfo?.recruiterCode,
      );
      if (recruiterProfile?.data?.status == "active") {
        const fullName = `${dataWithoutUndefined?.firstNameLocal}`;
        const dataCreateNPA = {
          body: {
            leaderofficecode: recruiterProfile?.data?.officeCode,
            recruiteragentcode: recruiterProfile?.data?.agentCode,
            leadername:
              recruiterProfile?.data?.agentType?.code == "AG"
                ? recruiterProfile?.data?.uplineAgent?.name?.enUs?.displayName
                : recruiterProfile?.data?.displayName?.enUs,
            leaderagentcode:
              recruiterProfile?.data?.agentType?.code == "AG"
                ? recruiterProfile?.data?.uplineAgent?.code
                : recruiterProfile?.data?.agentCode,
            recruitername: recruiterProfile?.data?.displayName?.enUs,
            idno: dataWithoutUndefined?.identityDocumentNumber,
            phoneno:
              "+62" +
              candidateOnboardingForm?.modules.personalData.contactInformation.questionAnswers
                .regionPhone[0].mobileNumber,
            paramsType: "true",
            npaToken: getNPAToken.data.npaToken,
            path: "/aob/inputcandidate",
            dob: moment(dataWithoutUndefined?.dateOfBirth).format("YYYY-MM-DD"),
            placeofbirth: dataWithoutUndefined?.placeOfBirth,
            name: fullName.trim(),
            recruiterofficecode: recruiterProfile?.data?.officeCode,
            email:
              candidateOnboardingForm?.modules.personalData.contactInformation.questionAnswers
                .emailAddress,
            isPruventure: false,
            pruventureCity: null,
            pruventureLevel: null,
            pruventureExperience: null,
            leaderNumberPV: "",
            channel: "PRUFORCEPULSE",
            // pruforcePulse:
            //   candidateOnboardingForm?.modules?.personalData?.identificationInformation
            //     .questionAnswers?.reinstateStatus === "Yes"
            //     ? "REINSTATE"
            //     : "",
          },
        };
        let tempNpaNumber = sessionStorage.getItem("tempNpaNumber");
        if (!tempNpaNumber) {
          const resCreateNPA = await postCreateNPA(dataCreateNPA);
          tempNpaNumber = resCreateNPA?.data?.body?.result?.npaNumber;
          if (tempNpaNumber !== undefined && tempNpaNumber !== null) {
            sessionStorage.setItem("tempNpaNumber", tempNpaNumber);
          }
        }
        const npaNumber = sessionStorage.getItem("tempNpaNumber");
        if (npaNumber !== undefined && npaNumber !== null) {
          const convertedData = {
            moduleName,
            npaNumber: npaNumber,
            templateId: formTemplate?.templateId,
            candidateId: candidateId,
            applicationId: candidateOnboardingForm?.applicationId,
            sections: [
              {
                sectionName,
                questionAnswers: stringifyNumbers(dataWithoutUndefined),
              },
            ],
          };
          const actionResponse = await dispatch(
            submitApplicationFormAsync({
              data: convertedData,
              action: formAction,
            }),
          );
          return actionResponse;
        } else {
          PruToast({
            message: getI18n().t("Common.network_error_502"),
            duration: 2000,
          });
          return { error: {} };
        }
      } else {
        PruToast({
          message: getI18n().t("Common.network_error_502"),
          duration: 2000,
        });
        return { error: {} };
      }
    } else {
      PruToast({
        message: getI18n().t("Common.network_error_502"),
        duration: 2000,
      });
      return { error: {} };
    }
  }

  if (sectionName == "contactInformation" && formAction === FormAction.SUBMIT) {
    const result: any = await confirm({
      message: getI18n().t("onboarding.address_pre_submit"),
      title: getI18n().t("reminder_title"),
      confirmButtonText: getI18n().t("onboarding.continue"),
      icon: <Icon svg={SvgAssets.notice} width={80} height={80} />,
    });
    if (!result.ok) {
      // return error: {} to keep screen stay, but also not toast errors
      return { error: {} };
    } else {
      const result = await fetchCandidateOnboardingForm(candidateId);
      let contentIdentityDocumentProof: any;
      let imgTypeIdDocProof: any;
      let contentImgCandidatePortrait: any;
      let imgTypeCandidatePortrait: any;
      let contentImgCandidateIjazah: any;
      let imgTypeCandidateIjazah: any;
      if (
        result.data[0].modules?.personalData?.identificationInformation?.status == "COMPLETED" &&
        result.data[0].modules?.personalData?.personalInformation?.status == "COMPLETED"
      ) {
        const imgIdentityDocumentProof =
          result.data[0].modules?.personalData?.identificationInformation?.questionAnswers
            ?.identityDocumentProof;
        const imgCandidatePortrait =
          result.data[0].modules?.personalData?.identificationInformation?.questionAnswers
            ?.candidatePortrait;
        const imgCandidateIjazah =
          result.data[0].modules?.personalData?.personalInformation?.questionAnswers
            ?.candidateIjazah;
        for (const b in imgIdentityDocumentProof) {
          contentIdentityDocumentProof = await getFile({
            applicationId: result.data[0].applicationId,
            resourceId: imgIdentityDocumentProof[b].content,
          });
          if (contentIdentityDocumentProof?.statusCode == 503) {
            PruToast({
              message: getI18n().t("Common.network_error_502"),
              duration: 2000,
            });
            return { error: {} };
          }
          imgTypeIdDocProof = contentIdentityDocumentProof.data.mimeType.split("/");
        }
        for (const a in imgCandidatePortrait) {
          contentImgCandidatePortrait = await getFile({
            applicationId: result.data[0].applicationId,
            resourceId: imgCandidatePortrait[a].content,
          });
          if (contentImgCandidatePortrait?.statusCode == 503) {
            PruToast({
              message: getI18n().t("Common.network_error_502"),
              duration: 2000,
            });
            return { error: {} };
          }
          imgTypeCandidatePortrait = contentImgCandidatePortrait.data.mimeType.split("/");
        }
        for (const c in imgCandidateIjazah) {
          contentImgCandidateIjazah = await getFile({
            applicationId: result.data[0].applicationId,
            resourceId: imgCandidateIjazah[c].content,
          });
          if (contentImgCandidateIjazah?.statusCode == 503) {
            PruToast({
              message: getI18n().t("Common.network_error_502"),
              duration: 2000,
            });
            return { error: {} };
          }
          imgTypeCandidateIjazah = contentImgCandidateIjazah.data.mimeType.split("/");
        }
        const joinCandidateAddress2 = `${dataWithoutUndefined?.blokNoKorespondensi.trim()}, ${dataWithoutUndefined?.rtKorespondensi.trim()}/${dataWithoutUndefined?.rwKorespondensi.trim()}`;
        const joinCandidateAddress3 = `${dataWithoutUndefined?.kelurahanKorespondensi.trim()}, ${dataWithoutUndefined?.kecamatanKorespondensi.trim()}`;
        const splitZipCodeKTP = dataWithoutUndefined?.kodePosKTP.split(" - ");
        const splitZipCodeDOM = dataWithoutUndefined?.kodePosDomisili.split(" - ");
        const splitZipCodeCOR = dataWithoutUndefined?.kodePosKorespondensi.split(" - ");
        const dataPayloadTemporary = {
          documents: [
            {
              mime: contentIdentityDocumentProof.data.mimeType,
              docId: "11010201",
              docType: imgTypeIdDocProof[1],
              fileDoc: contentIdentityDocumentProof.data.fileContent,
              fileType: imgTypeIdDocProof[0],
              scanTimestamp: moment().format("HH:mm"),
            },
            {
              mime: contentImgCandidatePortrait.data.mimeType,
              docId: "30010101",
              docType: imgTypeCandidatePortrait[1],
              fileDoc: contentImgCandidatePortrait.data.fileContent,
              fileType: imgTypeCandidatePortrait[0],
              scanTimestamp: moment().format("HH:mm"),
            },
            {
              mime: contentImgCandidateIjazah.data.mimeType,
              docId: "30020106",
              docType: imgTypeCandidateIjazah[1],
              fileDoc: contentImgCandidateIjazah.data.fileContent,
              fileType: imgTypeCandidateIjazah[0],
              scanTimestamp: moment().format("HH:mm"),
            },
          ],
          spouseDob:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .spouseDateOfBirth !== undefined
              ? moment(
                  result.data[0].modules?.personalData?.personalInformation?.questionAnswers
                    .spouseDateOfBirth,
                ).format("YYYY-MM-DD")
              : "",
          spouseJob:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .spouseEmploymentStatus || "",
          spouseName:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .spouseNameEn || "",
          spouseChild:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .childrenAndDependentNumber || "",
          candidateCity: dataWithoutUndefined?.kotaKabupatenKorespondensi,
          spouseCompany:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .spouseEmployedCompany || "",
          spouseIdCardNo:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .spouseIdentityDocumentNumber || "",
          candidateGender:
            result.data[0].modules?.personalData?.identificationInformation?.questionAnswers.sex ==
            "Male"
              ? "M"
              : "F",
          candidateAddress1: dataWithoutUndefined?.jalanKorespondensi.trim() || "",
          candidateAddress2: joinCandidateAddress2 || "",
          candidateAddress3: joinCandidateAddress3.substring(0, 29) || "",
          candidatePhoneNo: dataWithoutUndefined?.residentialNumber || "",
          candidateZipCode: splitZipCodeCOR[0],
          candidateProvince: splitZipCodeCOR[5],
          candidateReligion:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers.religion,
          candidateEducation:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .highestEducationLevel,
          candidatePlaceOfBirth:
            result.data[0].modules?.personalData?.identificationInformation?.questionAnswers
              .placeOfBirth,
          candidateMaritalStatus:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .maritalStatus,
          candidateGraduationYear: moment(
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .lastGraduationYear,
          ).format("YYYY"),
          candidateLastSchoolName:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .institutionNameEn,
          candidateLastSchoolLocation:
            result.data[0].modules?.personalData?.personalInformation?.questionAnswers
              .institutionLocation,
        };
        const payloadTemporary = {
          body: {
            npaNumber: result.data[0].npaNumber,
            processCode: "inputDataCandidate",
            payLoad: dataPayloadTemporary,
            submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
          access_token: "",
        };
        const resPayloadTemporary = await postPayloadTemporaryCandidateAddress(payloadTemporary);
        if (resPayloadTemporary.data.body.respCode == 200) {
          const inputDataCandidateSocialNetwork = [
            {
              accountName: dataWithoutUndefined?.facebookAccount || "",
              socialNetworkType: "Facebook",
            },
            {
              accountName: dataWithoutUndefined?.twitterAccount || "",
              socialNetworkType: "Twitter",
            },
            {
              accountName: dataWithoutUndefined?.linkedinAccount || "",
              socialNetworkType: "LinkedIn",
            },
            {
              accountName: dataWithoutUndefined?.instagramAccount || "",
              socialNetworkType: "Instagram",
            },
            {
              accountName: dataWithoutUndefined?.blogAccount || "",
              socialNetworkType: "Blog",
            },
            {
              accountName: dataWithoutUndefined?.otherAccount || "",
              socialNetworkType: "Lain-lain",
            },
          ];
          const payloadSocialMedia = {
            body: {
              npaNumber: result.data[0].npaNumber,
              processCode: "inputDataCandidateSocialNetwork",
              payLoad: inputDataCandidateSocialNetwork,
              submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            },
            access_token: "",
          };

          //inputDataCandidateAmandement
          const resPayloadSocialMedia = await postPayloadTemporary(payloadSocialMedia);
          if (resPayloadSocialMedia.data.body.respCode == 200) {
            const fullNameTwo = `${result.data[0].modules?.personalData?.identificationInformation?.questionAnswers?.firstNameLocal}`;
            const dataCandidateAmandement = {
              candidateName: fullNameTwo.trim(),
              candidateEmail: dataWithoutUndefined?.emailAddress,
              candidateDobStr: moment(
                result.data[0].modules?.personalData?.identificationInformation?.questionAnswers
                  .dateOfBirth,
              ).format("YYYY-MM-DD"),
              candidateIdCardNo:
                result.data[0].modules?.personalData?.identificationInformation?.questionAnswers
                  ?.identityDocumentNumber,
              candidateCellularNo1: "+62" + dataWithoutUndefined?.regionPhone[0].mobileNumber,
            };
            const payloadCandidateAmandement = {
              body: {
                npaNumber: result.data[0].npaNumber,
                processCode: "inputDataCandidateAmandement",
                payLoad: dataCandidateAmandement,
                submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
              },
              access_token: "",
            };
            const resPayloadCandidateAmandement = await postPayloadTemporary(
              payloadCandidateAmandement,
            );
            if (resPayloadCandidateAmandement.data.body.respCode == 200) {
              const dataCandidateAddress = {
                address: [
                  {
                    rt: dataWithoutUndefined?.rtKTP,
                    rw: dataWithoutUndefined?.rwKTP,
                    npa: result.data[0].npaNumber,
                    city: dataWithoutUndefined?.kotaKabupatenKTP,
                    type: "KTP",
                    street: dataWithoutUndefined?.jalanKTP,
                    blockNo: dataWithoutUndefined?.blokNoKTP,
                    zipCode: splitZipCodeKTP[0],
                    createdBy:
                      result.data[0].modules?.personalData?.identificationInformation
                        ?.questionAnswers?.firstNameLocal,
                    updatedBy:
                      result.data[0].modules?.personalData?.identificationInformation
                        ?.questionAnswers?.firstNameLocal,
                    subDistrict: dataWithoutUndefined?.kecamatanKTP,
                    provinceCode: splitZipCodeKTP[5],
                    provinceName: dataWithoutUndefined?.provinsiKTP,
                    urbanVillage: dataWithoutUndefined?.kelurahanKTP,
                  },
                  {
                    rt: dataWithoutUndefined?.rtDomisili,
                    rw: dataWithoutUndefined?.rwDomisili,
                    npa: result.data[0].npaNumber,
                    city: dataWithoutUndefined?.kotaKabupatenDomisili,
                    type: "DOMICILE",
                    street: dataWithoutUndefined?.jalanDomisili,
                    blockNo: dataWithoutUndefined?.blokNoDomisili,
                    zipCode: splitZipCodeDOM[0],
                    createdBy:
                      result.data[0].modules?.personalData?.identificationInformation
                        ?.questionAnswers?.firstNameLocal,
                    updatedBy:
                      result.data[0].modules?.personalData?.identificationInformation
                        ?.questionAnswers?.firstNameLocal,
                    subDistrict: dataWithoutUndefined?.kecamatanDomisili,
                    provinceCode: splitZipCodeDOM[5],
                    provinceName: dataWithoutUndefined?.provinsiDomisili,
                    urbanVillage: dataWithoutUndefined?.kelurahanDomisili,
                  },
                  {
                    rt: dataWithoutUndefined?.rtKorespondensi,
                    rw: dataWithoutUndefined?.rwKorespondensi,
                    npa: result.data[0].npaNumber,
                    city: dataWithoutUndefined?.kotaKabupatenKorespondensi,
                    type: "CORRESPONDENT",
                    street: dataWithoutUndefined?.jalanKorespondensi,
                    blockNo: dataWithoutUndefined?.blokNoKorespondensi,
                    zipCode: splitZipCodeCOR[0],
                    createdBy:
                      result.data[0].modules?.personalData?.identificationInformation
                        ?.questionAnswers?.firstNameLocal,
                    updatedBy:
                      result.data[0].modules?.personalData?.identificationInformation
                        ?.questionAnswers?.firstNameLocal,
                    subDistrict: dataWithoutUndefined?.kecamatanKorespondensi,
                    provinceCode: splitZipCodeCOR[5],
                    provinceName: dataWithoutUndefined?.provinsiKorespondensi,
                    urbanVillage: dataWithoutUndefined?.kelurahanKorespondensi,
                  },
                ],
              };
              const payloadCandidateAddress = {
                body: {
                  npaNumber: result.data[0].npaNumber,
                  processCode: "inputCandidateAddress",
                  payLoad: dataCandidateAddress,
                  submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                },
                access_token: "",
              };
              const resPayloadCandidateAddress = await postPayloadTemporary(
                payloadCandidateAddress,
              );
              if (resPayloadCandidateAddress.data.body.respCode != 200) {
                PruToast({
                  message: getI18n().t("Common.network_error_502"),
                  duration: 2000,
                });
                return { error: {} };
              }
            } else {
              PruToast({
                message: getI18n().t("Common.network_error_502"),
                duration: 2000,
              });
              return { error: {} };
            }
          } else {
            PruToast({
              message: getI18n().t("Common.network_error_502"),
              duration: 2000,
            });
            return { error: {} };
          }
        } else {
          PruToast({
            message: getI18n().t("Common.network_error_502"),
            duration: 2000,
          });
          return { error: {} };
        }
      } else {
        PruToast({
          message: getI18n().t("onboarding.required_data_information"),
          duration: 2000,
        });
        return { error: {} };
      }
    }
  }

  if (sectionName == "accountInformation" && formAction === FormAction.SUBMIT) {
    let contentBankAccountProof: any;
    let imgTypeBankAccountProof: any;
    let contentTaxPayerPortrait: any;
    let imgTypeTaxPayerPortrait: any;
    const result = await fetchCandidateOnboardingForm(candidateId);
    const imgBankAccountProof =
      result.data[0].modules?.personalData?.accountInformation?.questionAnswers?.bankAccountProof;
    const imgTaxPayerPortrait =
      result.data[0].modules?.personalData?.accountInformation?.questionAnswers?.taxPayerPortrait;
    for (const c in imgBankAccountProof) {
      contentBankAccountProof = await getFile({
        applicationId: result.data[0].applicationId,
        resourceId: imgBankAccountProof[c].content,
      });
      if (contentBankAccountProof?.statusCode == 503) {
        PruToast({
          message: getI18n().t("Common.network_error_502"),
          duration: 2000,
        });
        return { error: {} };
      }
      imgTypeBankAccountProof = contentBankAccountProof.data.mimeType.split("/");
    }
    if (dataWithoutUndefined?.taxStatus != "TIDAK ADA") {
      for (const d in imgTaxPayerPortrait) {
        contentTaxPayerPortrait = await getFile({
          applicationId: result.data[0].applicationId,
          resourceId: imgTaxPayerPortrait[d].content,
        });
        if (contentTaxPayerPortrait?.statusCode == 503) {
          PruToast({
            message: getI18n().t("Common.network_error_502"),
            duration: 2000,
          });
          return { error: {} };
        }
        imgTypeTaxPayerPortrait = contentTaxPayerPortrait.data.mimeType.split("/");
      }
    }
    const dataBankAccount = {
      bankName: dataWithoutUndefined?.bankNameAndCode,
      documents: [
        {
          mime: contentBankAccountProof.data.mimeType,
          docId: "13010209",
          docType: imgTypeBankAccountProof[1],
          fileDoc: contentBankAccountProof.data.fileContent,
          fileType: imgTypeBankAccountProof[0],
          scanTimestamp: moment().format("HH:mm"),
        },
      ],
      bankBranch: "",
      bankAccount: dataWithoutUndefined?.bankAccountNumber,
      bankAccountName: dataWithoutUndefined?.bankAccountName,
    };
    const payloadBankAccount = {
      body: {
        npaNumber: result.data[0].npaNumber,
        processCode: "inputDataCandidateBankAccount",
        payLoad: dataBankAccount,
        submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      access_token: "",
    };
    const resCandidateBankAccount = await postPayloadTemporary(payloadBankAccount);
    if (resCandidateBankAccount.data.body.respCode == 200) {
      let dataNPWP: any;
      if (dataWithoutUndefined?.taxStatus != "TIDAK ADA") {
        dataNPWP = {
          npwpNo: dataWithoutUndefined?.taxId,
          npwpCity: dataWithoutUndefined?.taxCity,
          npwpName: dataWithoutUndefined?.taxPayerNameEn,
          documents: [
            {
              mime: contentTaxPayerPortrait.data.mimeType,
              docId: "11010404",
              docType: imgTypeTaxPayerPortrait[1],
              fileDoc: contentTaxPayerPortrait.data.fileContent,
              fileType: imgTypeTaxPayerPortrait[0],
              scanTimestamp: moment().format("HH:mm"),
            },
          ],
          npwpStatus: dataWithoutUndefined?.taxStatus,
          npwpZipCode: dataWithoutUndefined?.taxPostalCode,
          npwpAddress1: dataWithoutUndefined?.taxAddress,
          npwpProvince: dataWithoutUndefined?.taxProvince,
        };
      } else {
        dataNPWP = {
          npwpNo: "",
          npwpCity: "",
          npwpName: "",
          documents: [
            {
              mime: "",
              docId: "",
              docType: "",
              fileDoc: "",
              fileType: "",
              scanTimestamp: moment().format("HH:mm"),
            },
          ],
          npwpStatus: "TIDAK ADA",
          npwpZipCode: "",
          npwpAddress1: "",
          npwpProvince: "",
        };
      }
      const payloadNPWP = {
        body: {
          npaNumber: result.data[0].npaNumber,
          processCode: "inputDataCandidateNpwp",
          payLoad: dataNPWP,
          submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        },
        access_token: "",
      };
      const resCandidateNPWP = await postPayloadTemporary(payloadNPWP);
      if (resCandidateNPWP.data.body.respCode != 200) {
        PruToast({
          message: getI18n().t("Common.network_error_502"),
          duration: 2000,
        });
        return { error: {} };
      }
    } else {
      PruToast({
        message: getI18n().t("Common.network_error_502"),
        duration: 2000,
      });
      return { error: {} };
    }
  }

  if (sectionName == "designationInformation" && formAction === FormAction.SUBMIT) {
    const result = await fetchCandidateOnboardingForm(candidateId);
    if (dataWithoutUndefined?.spouseAgentCode) {
      const getDataSpouse = await getDetailAgentSpouse(dataWithoutUndefined?.spouseAgentCode);
      if (getDataSpouse.code == "200") {
        const leaderCodeCandidate =
          result.data[0].modules?.agencyData.designationInformation.questionAnswers
            .managerAgentCode;
        const leaderNumberSpouse = getDataSpouse.data.leaderNumber;
        const agentCodeSpouse = getDataSpouse.data.spouseAgentCode;
        if (getDataSpouse.data.spouseAgentType == "AG") {
          if (
            leaderCodeCandidate != leaderNumberSpouse &&
            getDataSpouse.data.terminatedDate == null
          ) {
            const confirDiffUnit = await confirm({
              message: getI18n().t("onboarding.cancel_npa_spouse_is_agent_different_unit"),
              confirmButtonText: getI18n().t("onboarding.button_cancel_npa"),
              cancelButtonText: getI18n().t("app.button.back"),
              onCancel: () => {},
              onConfirm: async () => {
                await cancelNPA(result, agentCodeSpouse);
              },
              disableCancel: true,
            });
            if (confirDiffUnit.ok) {
              return { backToFak: true };
            } else {
              return { error: {} };
            }
          }
        } else {
          if (
            leaderCodeCandidate != agentCodeSpouse &&
            getDataSpouse.data.terminatedDate === null
          ) {
            const confirmSameunit = await confirm({
              message: getI18n().t("onboarding.cancel_npa_souse_is_agent_manager"),
              confirmButtonText: getI18n().t("onboarding.button_cancel_npa"),
              cancelButtonText: getI18n().t("app.button.back"),
              onCancel: () => {},
              onConfirm: async () => {
                await cancelNPA(result, agentCodeSpouse);
              },
              disableCancel: true,
            });
            if (confirmSameunit.ok) {
              return { backToFak: true };
            } else {
              return { error: {} };
            }
          }
        }
      } else if (getDataSpouse.code == "404") {
        confirm({
          message: getI18n().t("onboarding.check_spouse_is_agent_404"),
          confirmButtonText: "OK",
          disableCancel: true,
        });
        return { error: {} };
      } else {
        confirm({
          message: getI18n().t("Common.network_error_502"),
          confirmButtonText: "OK",
          disableCancel: true,
        });
        return { error: {} };
      }
    }
    const imgFormerResignation =
      result.data[0].modules?.agencyData.designationInformation.questionAnswers
        .formerInsuranceResignation;
    let contentFormerResignation: any;
    let imgTypeFormerResignation: any;
    for (const a in imgFormerResignation) {
      contentFormerResignation = await getFile({
        applicationId: result.data[0].applicationId,
        resourceId: imgFormerResignation[a].content,
      });
      if (contentFormerResignation?.statusCode == 503) {
        PruToast({
          message: getI18n().t("Common.network_error_502"),
          duration: 2000,
        });
        return { error: {} };
      }
      imgTypeFormerResignation = contentFormerResignation.data.mimeType.split("/");
    }
    let docResignFile: any = [];
    if (imgFormerResignation) {
      const dataContent = {
        mime: contentFormerResignation.data.mimeType,
        docId: "30020109",
        docType: imgTypeFormerResignation[1],
        fileDoc: contentFormerResignation.data.fileContent,
        fileType: imgTypeFormerResignation[0],
        scanTimestamp: moment().format("HH:mm"),
      };
      docResignFile.push(dataContent);
    }
    let dataPolicy = [];
    if (dataWithoutUndefined?.policyNumber) {
      if (dataWithoutUndefined?.policyNumber.length > 0) {
        for (var i = 0; i < dataWithoutUndefined?.policyNumber.length; i++) {
          dataPolicy.push(dataWithoutUndefined?.policyNumber[i]["Policy Number"]);
        }
      }
    }
    const inputDataCandidateAgency = {
      documents: docResignFile,
      isReinstate: "",
      polisNumber: dataPolicy || [],
      isAnyPolisPru: dataWithoutUndefined?.policyInsured == "true" ? "Ya" : "Tidak",
      spouseIsAgent: dataWithoutUndefined?.spouseAgent == "true" ? "Ya" : "Tidak",
      recruitMethode: dataWithoutUndefined?.recruitmentChannel,
      spouseAgentCode: dataWithoutUndefined?.spouseAgentCode || "",
      workLifeInsurance: dataWithoutUndefined?.formerInsuranceAgent == "true" ? "Ya" : "Tidak",
      candidateOfficeCode: dataWithoutUndefined?.agencyMarketingOffice,
      workGeneralInsurance: dataWithoutUndefined?.generalInsuranceAgent == "true" ? "Ya" : "Tidak",
      nameLifeInsuranceOffice: dataWithoutUndefined?.formerInsuranceName || "",
      nameGeneralInsuranceOffice: dataWithoutUndefined?.generalInsuranceName || "",
      newAgentAgreeGeneralInsuranceTACConvent:
        dataWithoutUndefined?.generanInsuranceDeclaration || false,
      newAgentAgreeGeneralInsuranceTACShariah:
        dataWithoutUndefined?.generanInsuranceShariaDeclaration || false,
    };
    const payloadCandidateAgency = {
      body: {
        npaNumber: result.data[0].npaNumber,
        processCode: "inputDataCandidateAgency",
        payLoad: inputDataCandidateAgency,
        submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      access_token: "",
    };
    const resCandidateAgency = await postPayloadTemporary(payloadCandidateAgency);
    if (resCandidateAgency?.data?.body?.respCode != 200) {
      PruToast({
        message: getI18n().t("Common.network_error_502"),
        duration: 2000,
      });
      return { error: {} };
    }
  }

  if (sectionName == "documentUploadSection" && formAction === FormAction.SUBMIT) {
    let supportDoc: any = [];
    const result = await fetchCandidateOnboardingForm(candidateId);

    const dataImg =
      result.data[0].modules?.documentUploadModule?.documentUploadSection?.questionAnswers;
    if (dataWithoutUndefined?.selectAkteLahir) {
      const data1 = await setPayloadSupportingDocument(
        dataImg?.uploadAkteLahir,
        result.data[0].applicationId,
        "11010203",
      );
      supportDoc.push(data1);
    }

    if (dataWithoutUndefined?.selectKartuKeluarga) {
      const data2 = await setPayloadSupportingDocument(
        dataImg?.uploadKartuKeluarga,
        result.data[0].applicationId,
        "11010207",
      );
      supportDoc.push(data2);
    }

    if (dataWithoutUndefined?.selectSuratNikah) {
      const data3 = await setPayloadSupportingDocument(
        dataImg?.uploadSuratNikah,
        result.data[0].applicationId,
        "11010210",
      );
      supportDoc.push(data3);
    }

    if (dataWithoutUndefined?.selectSuratPernyataanCalonAgen) {
      const data4 = await setPayloadSupportingDocument(
        dataImg?.uploadSuratPernyataanCalonAgen,
        result.data[0].applicationId,
        "30010103",
      );
      supportDoc.push(data4);
    }

    if (dataWithoutUndefined?.selectSuratKeteranganKelurahan) {
      const data5 = await setPayloadSupportingDocument(
        dataImg?.uploadSuratKeteranganKelurahan,
        result.data[0].applicationId,
        "30010104",
      );
      supportDoc.push(data5);
    }
    if (dataWithoutUndefined?.selectSuratResiKtpKelurahan) {
      const data6 = await setPayloadSupportingDocument(
        dataImg?.uploadSuratResiKtpKelurahan,
        result.data[0].applicationId,
        "30010105",
      );
      supportDoc.push(data6);
    }

    if (dataWithoutUndefined?.selectAkteKematian) {
      const data7 = await setPayloadSupportingDocument(
        dataImg?.uploadAkteKematian,
        result.data[0].applicationId,
        "30020104",
      );
      supportDoc.push(data7);
    }

    if (dataWithoutUndefined?.selectSuratPerceraian) {
      const data8 = await setPayloadSupportingDocument(
        dataImg?.uploadSuratPerceraian,
        result.data[0].applicationId,
        "30020105",
      );
      supportDoc.push(data8);
    }

    if (dataWithoutUndefined?.selectAkteKelahiranAnak) {
      const data9 = await setPayloadSupportingDocument(
        dataImg?.uploadAkteKelahiranAnak,
        result.data[0].applicationId,
        "30020107",
      );
      supportDoc.push(data9);
    }

    if (dataWithoutUndefined?.selectSuratPersetujuanPerusahaanAsuransiUmum) {
      const data10 = await setPayloadSupportingDocument(
        dataImg?.uploadSuratPersetujuanPerusahaanAsuransiUmum,
        result.data[0].applicationId,
        "30020102",
      );
      supportDoc.push(data10);
    }

    if (dataWithoutUndefined?.selectFormPemulihan) {
      const data11 = await setPayloadSupportingDocument(
        dataImg?.uploadFormPemulihan,
        result.data[0].applicationId,
        "80000001",
      );
      supportDoc.push(data11);
    }

    if (dataWithoutUndefined?.selectOthers) {
      const data12 = await setPayloadSupportingDocument(
        dataImg?.uploadOthers,
        result.data[0].applicationId,
        "80000002",
      );
      supportDoc.push(data12);
    }

    if (dataWithoutUndefined?.selectFormMinor1) {
      const data13 = await setPayloadSupportingDocument(
        dataImg?.uploadFormMinor1,
        result.data[0].applicationId,
        "30010102",
      );
      supportDoc.push(data13);
    }

    if (dataWithoutUndefined?.selectFormMinor2) {
      const data14 = await setPayloadSupportingDocument(
        dataImg?.uploadFormMinor2,
        result.data[0].applicationId,
        "30010107",
      );
      supportDoc.push(data14);
    }

    if (dataWithoutUndefined?.selectFormMinor3) {
      const data15 = await setPayloadSupportingDocument(
        dataImg?.uploadFormMinor3,
        result.data[0].applicationId,
        "30010111",
      );
      supportDoc.push(data15);
    }

    if (dataWithoutUndefined?.selectFormMinor4) {
      const data16 = await setPayloadSupportingDocument(
        dataImg?.uploadFormMinor4,
        result.data[0].applicationId,
        "30020101",
      );
      supportDoc.push(data16);
    }

    if (dataWithoutUndefined?.selectFormMinor5) {
      const data17 = await setPayloadSupportingDocument(
        dataImg?.uploadFormMinor5,
        result.data[0].applicationId,
        "30010106",
      );
      supportDoc.push(data17);
    }

    const inputDataCandidateAgency = { documents: supportDoc };
    const payloadSupportingDoc = {
      body: {
        npaNumber: result.data[0].npaNumber,
        processCode: "inputSuportingDocument",
        payLoad: inputDataCandidateAgency,
        submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      },
      access_token: "",
    };
    const resSupportingDoc = await postPayloadTemporary(payloadSupportingDoc);
    if (resSupportingDoc?.data?.body?.respCode != 200) {
      PruToast({
        message: getI18n().t("Common.network_error_502"),
        duration: 2000,
      });
      return { error: {} };
    }
  }

  if (sectionName == "eSignatureSection" && formAction === FormAction.SUBMIT) {
    const rawToken = getToken();
    const tokenData = rawToken ? parseJwt(rawToken) : {};
    const recruiterAgentCode = candidateOnboardingForm?.recruiterInfo?.recruiterCode;
    const recruiterIsLeader = recruiterAgentCode === tokenData.sub;
    switch (tokenData.role) {
      case RoleEnum.CANDIDATE:
        const result = await fetchCandidateOnboardingForm(candidateId);

        const imgCandidateSignature =
          result.data[0].modules?.eSignatureModule?.eSignatureSection?.questionAnswers
            ?.candidateSignature;
        const contentCandidateSignature = await getFile({
          applicationId: result.data[0].applicationId,
          resourceId: dataWithoutUndefined?.candidateSignature
            ? dataWithoutUndefined?.candidateSignature
            : imgCandidateSignature,
        });
        if (contentCandidateSignature?.statusCode == 503) {
          PruToast({
            message: getI18n().t("Common.network_error_502"),
            duration: 2000,
          });
          return { error: {} };
        }
        const dataCandidateSignature = {
          documents: [
            {
              mime: "image/png",
              docId: "30010110",
              docType: "png",
              fileDoc: contentCandidateSignature.data.fileContent,
              fileType: "image",
              scanTimestamp: moment().format("HH:mm"),
            },
          ],
        };
        const payloadCandidateSignature = {
          body: {
            npaNumber: result.data[0].npaNumber,
            processCode: "inputCandidateSignature",
            payLoad: dataCandidateSignature,
            submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
          access_token: "",
        };
        const resPayloadCandidateSignature = await postPayloadTemporary(payloadCandidateSignature);
        const resCloseNotif = await closeNotification({
          messageIdList: [notificationActionId],
          category: "inbox_candidate",
        });
        if (resPayloadCandidateSignature.data.body.respCode != 200) {
          PruToast({
            message: getI18n().t("Common.network_error_502"),
            duration: 2000,
          });
          return { error: {} };
        }
        break;
      case RoleEnum.AGENT:
        console.log("ini agent");
        break;
      case RoleEnum.MANAGER:
        console.log("ini manager");
        if (recruiterIsLeader) {
          console.log("ini manager as recruiter");
        }
        break;
      default:
        break;
    }
  }

  const npaNumber = candidateOnboardingForm?.npaNumber;
  const convertedData = {
    moduleName,
    npaNumber: npaNumber,
    templateId: formTemplate?.templateId,
    candidateId: candidateId,
    applicationId: candidateOnboardingForm?.applicationId,
    sections: [
      {
        sectionName,
        questionAnswers: stringifyNumbers(dataWithoutUndefined),
      },
    ],
  };
  if (moduleName !== OnboardingFormModuleName.PreQuestions) {
    if (
      sectionQuestionAnswers &&
      isEqual(sectionQuestionAnswers, dataWithoutUndefined) &&
      ([FormAction.SAVE, FormAction.VALIDATION].includes(formAction) ||
        (section.status === OnboardingApplicationSectionStatus.COMPLETED &&
          sectionName !== OnboardingFormSectionName.eSignatureSection))
    ) {
      return { noNeedToast: true };
    }
    if (
      sectionName === OnboardingFormSectionName.focusBusinessSection &&
      formAction === FormAction.SUBMIT
    ) {
      const result: any = await confirm({
        message: getI18n().t("confirm_finalized_onboarding_form_desc"),
        title: getI18n().t("reminder_title"),
        confirmButtonText: getI18n().t("onboarding.continue"),
        icon: <Icon svg={SvgAssets.notice} width={80} height={80} />,
      });
      formAction = FormAction.LOCK;
      if (!result.ok) {
        // return error: {} to keep screen stay, but also not toast errors
        return { error: {} };
      } else {
        const dataFocusbusiness = {
          focusBusiness: dataWithoutUndefined?.businessFocus == "true" ? "F" : "S",
        };
        const payloadFocusBusiness = {
          body: {
            npaNumber: candidateOnboardingForm?.npaNumber,
            processCode: "inputDataCandidateFocusBusiness",
            payLoad: dataFocusbusiness,
            submittedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
          access_token: "",
        };
        const resFocusBusiness = await postPayloadTemporary(payloadFocusBusiness);
        if (resFocusBusiness.data.body.respCode != 200) {
          PruToast({
            message: getI18n().t("Common.network_error_502"),
            duration: 2000,
          });
          return { error: {} };
        }
      }
    }
    const actionResponse = await dispatch(
      submitApplicationFormAsync({
        data: convertedData,
        // !!!NOTE: submit and lock the form data except E-Sig section
        action: formAction,
      }),
    );
    if (sectionName === OnboardingFormSectionName.eSignatureSection) {
      actionResponse.noNeedToast = true;
    }
    return actionResponse;
  } else {
    for (const section of convertedData.sections) {
      preQuestionsData[section.sectionName] = section;
    }
    const submitData: any = { ...convertedData, sections: Object.values(preQuestionsData) };
    // if this is the latest section of PreQuestions module, submit and create the form
    const surveyTemplate: Model = store.getState().onboarding.currentTemplate ?? {};
    const preModuleTemplate = surveyTemplate.pages?.find(
      (page) => page?.name === OnboardingFormModuleName.PreQuestions,
    );
    const lastPreSection = preModuleTemplate?.elements?.slice()?.reverse()?.[0];
    const isLastSection = sectionName === lastPreSection?.name;
    let result: any;
    if (sectionName === OnboardingFormSectionName.confirmationQuestions) {
      result = await dispatch(
        submitApplicationFormAsync({
          data: submitData,
          action: isLastSection ? FormAction.SUBMIT : FormAction.VALIDATION,
        }),
      );
    }
    if (isLastSection && formAction === FormAction.SUBMIT) {
      result = await dispatch(submitApplicationFormAsync({ data: submitData, action: formAction }));
    }
    return { ...result, noNeedToast: !isLastSection };
  }
};

export const getOnboardingModuleNameBySection = (
  formTemplate: any,
  sectionName: string,
  candidateId?: string,
) => {
  let moduleName = "" as OnboardingFormModuleName;
  if (!moduleName && sectionName && formTemplate) {
    moduleName = formTemplate.pages.find((page: any) => {
      return page.elements.find((section: any) => {
        if (section.name === sectionName) {
          candidateId &&
            GlobalHelper.setOnboardingCurrentSection({
              ...section,
              moduleName: page.name,
              candidateId,
            });
          return true;
        }
        return false;
      });
    }).name;
  }
  return moduleName;
};
